// extracted by mini-css-extract-plugin
module.exports = {"header":"Studies_header__ywNs8","headerBorderless":"Studies_headerBorderless__2BLsK","projectList":"Studies_projectList__3wjdy"};